// extracted by mini-css-extract-plugin
module.exports = {"goBack":"SelectImageRatioModal_goBack__1speK","errorMessage":"SelectImageRatioModal_errorMessage__31sZO"};